<template>
  <el-dialog
    :model-value="visible"
    :title="title"
    width="560px"
    append-to-body
    :close-on-click-modal="false"
    @update:model-value="onVisible"
  >
    <p v-if="message" class="reject-dialog__msg">{{ message }}</p>
    <AdminRejectReasonField
      v-model="reason"
      :category="category"
      :rows="4"
      :placeholder="placeholder"
      :extra-reasons="extraReasons"
    />
    <template #footer>
      <el-button @click="cancel">取消</el-button>
      <el-button type="danger" :disabled="!reason.trim()" @click="confirm">
        {{ confirmText }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import AdminRejectReasonField from '@/components/AdminRejectReasonField.vue'

export default {
  name: 'AdminRejectReasonDialog',
  components: { AdminRejectReasonField },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '填写驳回原因' },
    message: { type: String, default: '' },
    category: { type: String, default: 'content' },
    confirmText: { type: String, default: '确认驳回' },
    placeholder: {
      type: String,
      default: '点击上方常见原因加入，也可自行填写或修改'
    },
    extraReasons: { type: Array, default: () => [] },
    initialReason: { type: String, default: '' }
  },
  emits: ['cancel', 'confirm', 'update:visible'],
  data() {
    return { reason: this.initialReason || '' }
  },
  watch: {
    visible(v) {
      if (v) this.reason = this.initialReason || ''
    },
    initialReason(v) {
      if (this.visible) this.reason = v || ''
    }
  },
  methods: {
    onVisible(v) {
      this.$emit('update:visible', v)
      if (!v) this.$emit('cancel')
    },
    cancel() {
      this.$emit('update:visible', false)
      this.$emit('cancel')
    },
    confirm() {
      const text = String(this.reason || '').trim()
      if (!text) return
      this.$emit('confirm', text)
    }
  }
}
</script>

<style scoped>
.reject-dialog__msg {
  margin: 0 0 12px;
  font-size: 13px;
  color: var(--el-text-color-secondary);
  line-height: 1.5;
}
</style>
